<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div class="hig-cell-upgrade-container">
    @for (dataCells of data; track dataCells) {
        <div class="hig-cell-upgrade">
            <div class="hig-cell-upgrade-primary">{{ dataCells.primaryText | translate }}</div>
            <div class="hig-cell-upgrade-secondary">{{ dataCells.secondaryText | translate }}</div>
        </div>
    }
</div>
